export const PROJECT_DETAILS_REFRESH = 'PROJECT_DETAILS_REFRESH';
export const PROJECT_DETAILS_LOADED = 'PROJECT_DETAILS_LOADED';
export const PROJECT_DETAILS_UNLOAD = 'PROJECT_DETAILS_UNLOAD';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/actions/project.ts